var map = {
	"./BOOST.svg": 2365,
	"./GRAB.svg": 2366,
	"./MBB.svg": 2367,
	"./TNG.svg": 2368,
	"./direpay.svg": 2369,
	"./doitnow.svg": 2370,
	"./duitnow.svg": 2371,
	"./fpay.svg": 2372,
	"./fpay2.svg": 2373,
	"./fpx.svg": 2374,
	"./online_banking.svg": 2375,
	"./rapidpays.svg": 2376,
	"./secret_pay.svg": 2377,
	"./secret_pay_offline.svg": 2378,
	"./secret_pay_pro.svg": 2379,
	"./secret_pay_pro_b.svg": 2380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;